<template>
  <div class="text-lg">

    <h4 class="text-lg">
      {{ companyName }}
    </h4>

    <div>
      <b-row class="customer-container mt-1">
        <b-col
          class="text-left"
          xl="5"
          lg="6"
          md="12"
          sm="12"
          cols="12"
        >
          <h6>Nome:</h6>
          <p>{{ name }}</p>
        </b-col>
        <b-col
          class="text-left"
          xl="5"
          lg="6"
          md="12"
          sm="12"
          cols="12"
        >
          <h6>{{ taxId === 11 ? 'CPF' : taxId.length === 14 ? 'CNPJ' : 'Documento' }}:</h6>
          <p>{{ taxId | tax_id }}</p>
        </b-col>
        <b-col
          xl="2"
          class="text-left"
          lg="6"
          md="12"
          sm="12"
          cols="12"
        >
          <h6>Telefone:</h6>
          <p>{{ phone }}</p>
        </b-col>

        <b-col
          xl="5"
          lg="6"
          md="12"
          class="text-left"
          sm="12"
          cols="12"
        >
          <h6>E-mail:</h6>
          <p>{{ email }}</p>
        </b-col>

        <b-col
          xl="5"
          lg="6"
          md="12"
          class="text-left"
          sm="12"
          cols="12"
        >
          <h6>Renda Mensal:</h6>
          <p>{{ monthlyIncome | value }}</p>
        </b-col>
        <b-col />
      </b-row>
    </div>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
  },

  props: {
    leadId: {
      default: () => '',
      type: String,
    },
    name: {
      default: () => '',
      type: String,
    },

    companyName: {
      default: () => '',
      type: String,
    },

    taxId: {
      default: () => '',
      type: String,
    },

    phone: {
      default: () => '',
      type: String,
    },

    email: {
      default: () => '',
      type: String,
    },

    companyType: {
      default: () => '',
      type: String,
    },

    monthlyIncome: {
      default: () => 0,
      type: Number,
    },
  },
}
</script>

<style lang="scss" scoped>
    @import "@core/scss/base/components/info-card.scss";
</style>
